import cx from 'classnames';
import { useParams } from 'react-router';

import { bridge } from 'bridge';

import useI18next from 'services/i18n';

import { Error as ErrorPage } from './components/Error/Error';
import styles from './FakeDoor.module.scss';
import { useFakeDoor } from './useFakeDoor';

const METHOD_NAME = 'fakeDoorCTAclick';

export const FakeDoorModule = () => {
    const { featureId } = useParams<{ featureId: string }>();
    const { isTranslationsLoaded } = useI18next();

    const fakeDoor = useFakeDoor(featureId);

    if (!isTranslationsLoaded || !fakeDoor) {
        return <ErrorPage />;
    }

    const handleNotifyMe = () => {
        if (!featureId) {
            return;
        }

        bridge.send(METHOD_NAME, { featureId });
    };

    return (
        <main className={styles.wrapper}>
            <div className={`${styles.ellipse} ${styles.ellipseTop}`} />
            <div className={`${styles.ellipse} ${styles.ellipseBottom}`} />
            <div className={styles.content}>
                <img src={fakeDoor?.image} alt="" className={styles.image} />
                <h1 className={styles.title}>{fakeDoor?.title}</h1>
                <p className={styles.description}>{fakeDoor?.description}</p>
                <button type="button" onClick={handleNotifyMe} className={styles.button}>
                    {fakeDoor?.button}
                </button>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>{fakeDoor?.benefits?.title}</h2>
                    <ul className={styles.benefits}>
                        {fakeDoor?.benefits?.list?.map((benefit) => (
                            <li key={benefit.title} className={styles.benefit}>
                                <div className={styles.listMarker} />
                                <div className={styles.benefitContent}>
                                    <h3 className={styles.benefitTitle}>{benefit.title}</h3>
                                    <p className={styles.benefitDescription}>{benefit.description}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>{fakeDoor?.instructions?.howItWorksTitle}</h2>
                    <ol className={styles.instructions}>
                        {fakeDoor?.instructions?.list?.map((instruction) => (
                            <li key={instruction} className={styles.instruction}>
                                <div className={styles.instructionContent}>
                                    <p className={styles.instructionDescription}>{instruction}</p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </section>
                <section className={cx(styles.section, styles.centered)}>
                    <h2 className={styles.footerTitle}>{fakeDoor?.footer?.title}</h2>
                    <p className={styles.description}>{fakeDoor?.footer?.description}</p>
                    <button type="button" onClick={handleNotifyMe} className={styles.button}>
                        {fakeDoor?.footer?.button}
                    </button>
                </section>
            </div>
        </main>
    );
};
